import React, { useState, useEffect } from "react";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Divider } from "antd";
import dayjs from "dayjs";
import jwt_decode from "jwt-decode";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { decryptRequest } from "../../utils/crypt";
import { DropDownValues } from "../../services/Filters";
import { createAlert, getManualAlertsList } from "../../services/AlertsTable";
import AddAlertForm from "./AddAlertForm";
import AddAlertTable from "./AddAlertTable";
import FiltersDropdown from "./FiltersDropdown";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CommonButton from "../../common/commonbutton/CommonButton";

const beforeUpload = (file) => {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("Image must smaller than 2MB!");
  }
  return isJpgOrPng && isLt2M;
};

function AddAlert() {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(dayjs().subtract(1, "month"));
  const [endDate, setEndDate] = useState(dayjs());
  const [startTime, setStartTime] = useState(dayjs().startOf("day"));
  const [endTime, setEndTime] = useState(dayjs());

  const [tableData, setTableData] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [accessValue, setAccessValue] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [cameraoptions, setCameraOptions] = useState([]);
  const [alertoptions, setAlertOptions] = useState([]);
  const [locationoptions, setLocationOptions] = useState([]);
  const [optionSelected, setoptionSelected] = useState(null);
  const [cameraOptionSelected, setcameraoptionSelected] = useState();
  const [statusOptionSelected, setStatusoptionSelected] = useState();
  const [locationOptionSelected, setLocationoptionSelected] = useState();
  const [alertsAssignedMailsoptions, setalertsAssignedMailsOptions] = useState(
    []
  );
  const [esscalationEmailsoptions, setesscalationEmailsOptions] = useState([]);
  const [alertsAssignedMailsSelected, setalertsAssignedMailsSelected] =
    useState([]);
  const [esscalationEmailsSelected, setesscalationEmailsSelected] = useState(
    []
  );
  const [imageFileList, setImageFileList] = useState([]);
  const [Image, setImage] = React.useState("");
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const handleOpenImageModal = () => setImageModalOpen(true);
  const handleCloseImageModal = () => {
    setImageModalOpen(false);
  };

  const getFiltersData = async () => {
    let dropDownValues = await DropDownValues();
    let { alerts, cameras, locations, emails } = dropDownValues;
    if (alerts.length > 0 && cameras.length > 0 && locations.length > 0) {
      setAlertOptions(alerts);
      setCameraOptions(cameras);
      setLocationOptions(locations);
      setalertsAssignedMailsOptions(emails);
      setesscalationEmailsOptions(emails);
    }
  };
  const handleStatusChange = (selected) => {
    setStatusoptionSelected(selected);
  };
  const handleLocationChange = (selected) => {
    setLocationoptionSelected(selected);
  };
  const handleAlertChange = (selected) => {
    setoptionSelected(selected);
  };
  const handleCameraChange = (selected) => {
    setcameraoptionSelected(selected);
  };
  const handleChangeAletsAssignedEmails = (selected) => {
    setalertsAssignedMailsSelected(selected);
  };
  const handleChangeEsscalationEmail = (selected) => {
    setesscalationEmailsSelected(selected);
  };

  const getManualAlertsListData = async () => {
    const params = {
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
      startTime: startTime.format("HH:mm:ss"),
      endTime: endTime.format("HH:mm:ss"),
      camera: cameraOptionSelected?.length > 0 ? cameraOptionSelected : [],
      status: statusOptionSelected?.length > 0 ? statusOptionSelected : [],
      alert: optionSelected?.length > 0 ? optionSelected : [],
      location:
        locationOptionSelected?.length > 0 ? locationOptionSelected : null,
      alertsAssignedMails:
        alertsAssignedMailsSelected?.length > 0
          ? alertsAssignedMailsSelected
          : [],
    };
    let alertsListData = await getManualAlertsList(params);
    setTableData(alertsListData?.data?.data);
  };

  useEffect(() => {
    let token = localStorage.getItem("token");
    let path = localStorage.getItem("path");
    if (path == "/addalert") {
      setIsActive(true);
    }
    var decoded = jwt_decode(token);
    let { encryptedData } = decoded;
    decryptRequest(encryptedData).then((res) => {
      let { name, email, userType } = JSON.parse(res).data;
      setName(name);
      setEmail(email);
      setAccessValue(userType);
    });
    getFiltersData();
    getManualAlertsListData();
  }, []);

  const [imageUrl, setImageUrl] = useState();
  const handleChange = (info) => {
    let fileList = [...info.fileList];
    fileList = fileList.map((file) => {
      if (file.response) {
        file.url = file.response.url;
        file.thumbUrl = file.response.url;
        setImageUrl(file.url);
      }
      return file;
    });
    setImageFileList(fileList);
  };

  const handleRemove = (file) => {
    const updatedFileList = imageFileList.filter(
      (item) => item.uid !== file.uid
    );
    setImageFileList(updatedFileList);
    setImageUrl("");
  };

  const handleAddAlert = async (values) => {
    if (imageUrl == null) {
      toast("Image is required");
    } else {
      values.image = imageUrl;
      let params = { ...values };
      let createAlertResponse = await createAlert(params);
      if (createAlertResponse.status == 201) {
        toast(createAlertResponse.message);
        setImageFileList([]);
        setImageUrl(null);
        getManualAlertsListData();
        navigate("/addalert");
      } else {
        toast("Something went wrong");
      }
    }
  };
  const ExportToExcel = ({ apiData, fileName }) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const exportToCSV = (apiData, fileName) => {
      console.log("Api Data ----> ", apiData);
      let userSheetData = apiData.map((item) => {
        return {
          Date: item.date,
          time: item.time,
          alert: item.alert,
          camera: item.camera,
          status: item.status ? item.status : "",
          image: {
            s: { color: "blue" },
            t: "s",
            v: `${item.image}`,
            l: { Target: `${item.image}`, Tooltip: "Download Image" },
          },
          comments:
            item.comments.length > 0
              ? JSON.stringify(
                  item.comments.map((item) => {
                    return {
                      name: item.name,
                      comment: item.comment,
                      date: item.date,
                      time: item.time,
                    };
                  })
                )
              : "No Comments ",
          AlertsAssignedTo:
            item.alertsAssignedMails?.length > 0
              ? JSON.stringify(
                  item.alertsAssignedMails.map((item) => {
                    return item;
                  })
                )
              : "UnAssigned",
        };
      });
      const ws = XLSX.utils.json_to_sheet(userSheetData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    };

    return (
      <div className="w-1/2">
        <CommonButton
          onClick={(e) => exportToCSV(apiData, fileName)}
          icon={FileUploadIcon}
        >
          Export
        </CommonButton>
      </div>
    );
  };

  return (
    <div className="p-2">
      <Divider />
      <div className="flex justify-center">
        <span className="text-teal-700 text-lg font-semibold">
          Manual Incident Submission
        </span>
      </div>
      <Divider />
      <div className="flex flex-col space-y-2">
        <AddAlertForm
          handleAddAlert={handleAddAlert}
          alertoptions={alertoptions}
          locationoptions={locationoptions}
          cameraoptions={cameraoptions}
          alertsAssignedMailsoptions={alertsAssignedMailsoptions}
          esscalationEmailsoptions={esscalationEmailsoptions}
          imageFileList={imageFileList}
          beforeUpload={beforeUpload}
          handleChange={handleChange}
          handleRemove={handleRemove}
          image={imageUrl}
          handleGetData={getManualAlertsListData}
        />
        <Divider />
        <div className="w-full flex justify-end items-center gap-2">
          <div className="">
            <ExportToExcel
              apiData={tableData}
              fileName={"Manual Alerts Sheet"}
              className="border-2 border-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-600 hover:text-white transition-colors"
            />
          </div>
          <div className="mt-4">
            {" "}
            <FiltersDropdown
              startDate={startDate}
              setStartDate={setStartDate}
              startTime={startTime}
              setStartTime={setStartTime}
              endDate={endDate}
              setEndDate={setEndDate}
              endTime={endTime}
              setEndTime={setEndTime}
              locationOptions={locationoptions}
              locationOptionSelected={locationOptionSelected}
              handleLocationChange={handleLocationChange}
              cameraoptions={cameraoptions}
              cameraOptionSelected={cameraOptionSelected}
              handleCameraChange={handleCameraChange}
              alertoptions={alertoptions}
              optionSelected={optionSelected}
              handleAlertChange={handleAlertChange}
              statusOptionSelected={statusOptionSelected}
              handleStatusChange={handleStatusChange}
              handleGetData={getManualAlertsListData}
              alertsAssignedMailsoptions={alertsAssignedMailsoptions}
              handleChangeAletsAssignedEmails={handleChangeAletsAssignedEmails}
              alertsAssignedMailsSelected={alertsAssignedMailsSelected}
            />
          </div>
        </div>
        <AddAlertTable
          tableData={tableData}
          alertsAssignedMailsoptions={alertsAssignedMailsoptions}
          esscalationEmailsoptions={esscalationEmailsoptions}
          imageModalOpen={imageModalOpen}
          handleOpenImageModal={handleOpenImageModal}
          handleCloseImageModal={handleCloseImageModal}
          Image={Image}
          setImage={setImage}
          name={name}
          email={email}
          getManualAlertsList={getManualAlertsListData}
        />
      </div>
    </div>
  );
}

export default AddAlert;
